export default __webpack_public_path__ + "static/media/Description_Section_Resized.1bfb12b8.png";